import React, { useEffect, useState } from "react";
import { useOperadorCaixa } from "../../../../../context/OperadorCaixaContext";
import { Loader } from "../../../../generics/loader";
import Select from "react-select";
import makeAnimated from "react-select/animated";

interface Processos {
  id_processo: string;
  label: string;
}

export default function FiltrosFilaCobranca() {
  const {
    assessorias,
    loadAssessorias,
    vendedores,
    filtros,
    data: infos,
    loadVendedores,
    loadData,
    setFiltros,
    setPage,
    page
  } = useOperadorCaixa();
  const [loading, setLoading] = useState(false);
  const [assessoria, setAssessoria] = useState(filtros.assessoria ?? "all");
  const [processos, setProcessos] = useState<Processos[]>([]);
  const [processosOptions, setProcessosOptions] = useState([]);
  const [to, setTo] = useState(filtros.ate ?? 0);
  const [from, setFrom] = useState(filtros.de ?? 0);
  const [valueTo, setValueTo] = useState(filtros.valor_final ?? 0);
  const [valueFrom, setValueFrom] = useState(filtros.valor_inicial ?? 0);
  const [vendedor, setVendedor] = useState(filtros.vendedor ?? "all");
  const [data, setData] = useState(filtros.data ?? "");
  const [agendamentos, setAgendamentos] = useState(
    filtros.agendamentos ?? "TODOS"
  );
  const [acionamentos, setAcionamentos] = useState(
    filtros.acionamentos === "sim" ? true : false
  );

  const animatedComponents = makeAnimated();

  function addOneDay(dateStr: string) {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  }

  async function handleLoadWithFilters() {
    let newDate = "";
    if (data !== "") {
      newDate = addOneDay(data);
    }
    // setPage(1);
    const newProcessos = processos.map((processo) => processo.id_processo);
    setFiltros({
      page: page,
      assessoria: !assessoria || assessoria === "all" ? undefined : assessoria,
      de: from === 0 ? undefined : from,
      ate: to === 0 ? undefined : to,
      valor_inicial: valueFrom === 0 ? undefined : valueFrom,
      valor_final: valueTo === 0 ? undefined : valueTo,
      vendedor: !vendedor || vendedor === "all" ? undefined : vendedor,
      data: data ? newDate : undefined,
      agendamentos: agendamentos,
      acionamentos: acionamentos === true ? "SIM" : undefined,
      processos:
        processos.length > 0 ? JSON.stringify(newProcessos) : undefined,
    });
    await loadData({
      page: page,
      assessoria: !assessoria || assessoria === "all" ? undefined : assessoria,
      de: from === 0 ? undefined : from,
      ate: to === 0 ? undefined : to,
      valor_inicial: valueFrom === 0 ? undefined : valueFrom,
      valor_final: valueTo === 0 ? undefined : valueTo,
      vendedor: !vendedor || vendedor === "all" ? undefined : vendedor,
      data: data ? newDate : undefined,
      agendamentos: agendamentos,
      acionamentos: acionamentos === true ? "SIM" : undefined,
      processos:
        processos.length > 0 ? JSON.stringify(newProcessos) : undefined,
    });
  }

  function clearFilters() {
    setAssessoria("all");
    setProcessos([]);
    setTo(0);
    setFrom(0);
    setValueTo(0);
    setValueFrom(0);
    setVendedor("all");
    setData("");
    setAgendamentos("TODOS");
    setAcionamentos(false);
  }
  async function clearAndReload() {
    setLoading(true);
    clearFilters();
    setPage(0)
    setFiltros({
      page: 0,
    });
    await loadData({
      page: 0,
    });
    setLoading(false);
  }
  useEffect(() => {
    const processos = infos?.data.map((inf) => {
      return {
        id_processo: inf.id_processo,
        value: inf.id_processo,
        label: `${inf.id_processo} - ${inf.processo}`,
      };
    });
    const newProcessos =
      processos?.reduce(
        (
          unique: Array<{ value: string; label: string }>,
          current: { value: string; label: string }
        ) => {
          const exist = unique.findIndex(
            (item: { value: string; label: string }) =>
              item.value === current.value
          );
          if (exist === -1) {
            unique.push(current);
          }
          return unique;
        },
        []
      ) ?? [];
    setProcessosOptions(newProcessos as []);
  }, [infos]);

  useEffect(() => {
    setLoading(true);
    loadAssessorias();
    loadVendedores();
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    handleLoadWithFilters();
    setLoading(false);
  }, []);

  return (
    <div className="w-[100%]">
      <div className="flex w-[100%] items-center justify-between">
        <div className="flex flex-col space-y-2">
          <label className="font-bold text-slate-400" htmlFor="assessoria">
            Assessoria
          </label>
          <select
            id="assessoria"
            className="w-60 rounded-lg border p-2"
            value={assessoria}
            onChange={(e) => setAssessoria(e.target.value)}
          >
            <option value="all">Todas</option>
            {!assessorias || assessorias.length < 1 || loading ? (
              <Loader />
            ) : (
              <>
                {assessorias?.map((assessoria) => (
                  <option value={assessoria.assessoria}>
                    {assessoria.assessoria}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>

        <div className="flex flex-col justify-items-start space-y-4">
          <label className="-mb-2 font-bold text-slate-400">
            Dias em atraso
          </label>
          <div className="flex items-center space-x-2">
            <label>De:</label>
            <input
              defaultChecked={true}
              className="h-10 w-20 rounded border p-1"
              type="number"
              min={0}
              value={from}
              onChange={(e) => setFrom(Number(e.target.value))}
            />
            <label>Até:</label>
            <input
              className="h-10 w-20 rounded border p-1"
              type="number"
              min={0}
              value={to}
              onChange={(e) => setTo(Number(e.target.value))}
            />
          </div>
        </div>

        <div className="flex flex-col space-y-2">
          <label className="font-bold text-slate-400" htmlFor="vendedor">
            Vendedor
          </label>
          <select
            id="vendedor"
            className="w-64 rounded-lg border p-2"
            value={vendedor}
            onChange={(e) => setVendedor(e.target.value)}
          >
            <option value="all">Todos</option>
            {!vendedores || vendedores.length < 1 || loading ? (
              <Loader />
            ) : (
              <>
                {vendedores?.map((vendedor) => (
                  <option value={vendedor.nome_vendedor}>
                    {vendedor.nome_vendedor}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>

        <div className="flex w-44 flex-col space-y-2">
          <label
            className="font-bold text-slate-400"
            htmlFor="ultimo_acionamento"
          >
            Último acionamento
          </label>
          <input
            type="date"
            id="ultimo_acionamento"
            className="rounded-lg border p-1.5"
            value={data}
            onChange={(e) => setData(e.target.value)}
          />
        </div>

        <div className="flex flex-col justify-items-start space-y-4">
          <label className="-mt-2 font-bold text-slate-400">
            Tem agendamentos?
          </label>
          <div className="flex items-center space-x-2">
            <input
              checked={agendamentos === "TODOS"}
              className="form-radio h-5 w-5 bg-primary"
              type="radio"
              name="opcaoRadio"
              value="TODOS"
              onChange={(e) => setAgendamentos(e.target.value)}
            />
            <label>Todos</label>
            <input
              checked={agendamentos === "SIM"}
              className="form-radio h-5 w-5 bg-primary"
              type="radio"
              name="opcaoRadio"
              value="SIM"
              onChange={(e) => setAgendamentos(e.target.value)}
            />
            <label>Sim</label>
            <input
              checked={agendamentos === "NAO"}
              className="form-radio h-5 w-5 bg-primary"
              type="radio"
              name="opcaoRadio"
              value="NAO"
              onChange={(e) => setAgendamentos(e.target.value)}
            />
            <label>Não</label>
          </div>
        </div>

        <div className="flex flex-col space-y-2">
          <label
            className="-mt-2 mb-2 font-bold text-slate-400"
            htmlFor="acionamentos"
          >
            Acionamentos?
          </label>
          <div className="mt-2 flex items-center text-center">
            <input
              className="form-checkbox h-5 w-5"
              type="checkbox"
              checked={acionamentos}
              onChange={() => setAcionamentos(!acionamentos)}
              id="acionamentos"
            />
            <span className="ml-2">Clientes sem acionamento</span>
          </div>
        </div>
        <div className="flex space-x-2">
          <button
            className="rounded-lg bg-slate-100 px-6 py-2 font-bold text-blueGray-700"
            onClick={clearAndReload}
          >
            Limpar
          </button>
          <button
            className="rounded-lg bg-primary px-6 py-2 font-bold text-white"
            onClick={() => {
              setPage(1);
              handleLoadWithFilters()
            }}
          >
            Filtrar
          </button>
        </div>
      </div>

      <div className="mt-2 flex w-[100%] space-y-2">
        <div className="flex flex-col justify-items-start space-y-4">
          <label className="-mb-2 font-bold text-slate-400">
            Valor vencido
          </label>
          <div className="flex items-center space-x-2">
            <label>De:</label>
            <input
              defaultChecked={true}
              className="h-10 w-20 rounded border p-1"
              type="number"
              min={0}
              value={valueFrom}
              onChange={(e) => setValueFrom(Number(e.target.value))}
            />
            <label>Até:</label>
            <input
              className="h-10 w-20 rounded border p-1"
              type="number"
              min={0}
              value={valueTo}
              onChange={(e) => setValueTo(Number(e.target.value))}
            />
          </div>
        </div>
        <div className="ml-3 flex w-[100%] flex-col">
          <label className="font-bold text-slate-400" htmlFor="assessoria">
            Processos
          </label>
          <Select
            closeMenuOnSelect={false}
            components={animatedComponents}
            isMulti
            value={processos}
            onChange={(e) => setProcessos(e as [])}
            options={processosOptions}
          />
        </div>
      </div>
    </div>
  );
}
